import { useStore } from '../store'

const STEPS = [
  ['🎬', 'Thêm video', 'Kéo-thả 1 hoặc nhiều video để ghép.'],
  ['🎙️', 'Phiên âm & cắt', 'Bấm Phiên âm rồi click vào chữ để cắt, hoặc gõ lệnh cho trợ lý 🤖.'],
  ['🎨', 'Style DNA + Logo', 'Trích chất màu từ video mẫu, chèn logo che watermark.'],
  ['📐', 'Xuất đa nền tảng', 'Chọn 9:16 / 16:9 / 1:1 và bấm Xuất.'],
]

/** GĐ8 — Onboarding lần đầu. */
export function Onboarding() {
  const seen = useStore((s) => s.onboardingSeen)
  const dismiss = useStore((s) => s.dismissOnboarding)
  if (seen) return null

  return (
    <div className="overlay" onClick={dismiss}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <h2>👋 Chào mừng đến BrandCut</h2>
        <p className="muted">AI video editor học phong cách của chính bạn — xử lý 100% trên máy, không upload.</p>
        <div className="steps">
          {STEPS.map(([icon, title, desc]) => (
            <div key={title} className="step">
              <div className="step-icon">{icon}</div>
              <div>
                <b>{title}</b>
                <div className="muted" style={{ fontSize: 12 }}>{desc}</div>
              </div>
            </div>
          ))}
        </div>
        <button className="btn primary" onClick={dismiss}>Bắt đầu</button>
      </div>
    </div>
  )
}
